import { Pipe, PipeTransform } from 'angular-ts-decorators';
import { Languages } from '../services/languages';

export type LanguageNameFilter = (input: string) => string;

interface ILanguageName {
  transform: LanguageNameFilter;
}

/**
 * Filter that maps 2 letter language code to full language name
 * @param {string} input 2 letter language code: 'nl', 'en' etc
 * @return {string} full language name in the current application langauge
 */
@Pipe({ name: 'languageName' })
export class LanguageNamePipe implements PipeTransform, ILanguageName {
  constructor(
    private languages: Languages,
    private $translate: ng.translate.ITranslateService,
  ) {
    'ngInject';
  }

  public transform(input: string): string {
    if (angular.isString(input)) {
      let language = this.languages.getLanguageNameByCode(input);

      if (language) {
        return language;
      } else {
        return this.$translate.instant('core.unknown');
      }
    } else {
      return this.$translate.instant('core.unknown');
    }
  }
}
